// extracted by mini-css-extract-plugin
export var closeButton = "_lf-1";
export var closeX = "_lf-3";
export var container = "_lf-0";
export var image = "_lf-2";